import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { run_chat_messages_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';

import { ChatMessage } from '@/types/runs.ts';

type props = {
  run_id: string;
  content: string;
};

const useAddChatMessage = (
  options?: UseMutationOptions<ChatMessage, AxiosError, props>,
): UseMutationResult<ChatMessage, AxiosError, props> => {
  const apiClient = useApiClient();

  return useMutation({
    mutationFn: async ({ run_id, content }: props) => {
      const response = await apiClient.post<ChatMessage>(run_chat_messages_url(run_id), {
        content: content,
      });
      return response.data;
    },
    ...options,
  });
};

export default useAddChatMessage;
